module.exports = __webpack_public_path__ + "fonts/AvenirBlack.8aa8563.ttf";